export enum EvaluationDuration {
  Split = 30,
  Single = 60,
}

/** The format the API responds with, lists of ISO dates grouped by day */
export type RawAvailableTimes = Record<string, string[]>;

/** A more ergonomic API used internally */
export type AvailableTimes = {
  day: Date;
  availableTimes: Date[];
}[];

export type RawScheduleAvailableTimes = Record<
  string,
  {
    calendarID: string;
    therapistName: string;
    availableTimes: Date[];
  }[]
>;

export type CalendarTimeSlot = {
  calendarID: number;
  therapistName: string;
  time: Date;
};

/** Reduced therapist object for specific use within signup and scheduling features */
export type SmallTherapist = {
  therapistID: string;
  firstName: string;
  lastName: string;
  acuityCalendarID: string;
  therapistEmail: string;
};

export type EvaluationTimeSlotSummaryRaw = {
  therapists: SmallTherapist[];
  times: {
    time: string;
    therapistEmails: string[];
  }[];
};

export type EvaluationTimeSlotSummary = {
  therapists: SmallTherapist[];
  times: {
    time: Date;
    therapistEmails: string[];
  }[];
};

export type ScheduleAvailableTimes = {
  day: Date;
  availableTimes: CalendarTimeSlot[];
};

export interface AvailabilityItem {
  time: string;
  isAvailableNextWeek: boolean;
  conflicts?: {
    datetime: string;
    type: 'appointmentExists' | 'overDirectHoursLimit' | 'overWeeklyLimit' | 'overDailyLimit' | 'consecutiveApptsLimit';
  }[];
}

export interface RawAvailabilityResponse {
  therapistName: string;
  therapistEmail: string;
  items: AvailabilityItem[];
}
